import { atom } from 'jotai'
import { BeneficiaryDetails } from 'types/beneficiaries'
import { BvnkNetworkConnection } from 'types/bvnkNetwork'
import { ContactPaymentInstruments } from 'types/contacts'
import { FiatSendFormProps } from '../../FiatSend/types'
import { SourcePayWallet } from '../types'

export const selectedFiatBeneficiaryAtom = atom<BeneficiaryDetails | null>(
  null as BeneficiaryDetails
)
selectedFiatBeneficiaryAtom.debugLabel = 'selected-fiat-beneficiary'

export const selectedContactBankAccountAtom = atom<ContactPaymentInstruments | null>(
  null as ContactPaymentInstruments
)
selectedContactBankAccountAtom.debugLabel = 'selected-contact-bank-account'

export const selectedBvnkNetworkBeneficiaryAtom = atom<BvnkNetworkConnection | null>(
  null as BvnkNetworkConnection
)
selectedBvnkNetworkBeneficiaryAtom.debugLabel = 'selected-bvnk-network-beneficiary'

export const selectedWalletAtom = atom<SourcePayWallet | null>(null as SourcePayWallet)
selectedWalletAtom.debugLabel = 'selected-wallet'

export const fiatSendFormAtom = atom<FiatSendFormProps | null>(null as FiatSendFormProps)
fiatSendFormAtom.debugLabel = 'fiat-send-form'
